export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/linkedin_profiles.d9f5f5f.svg";